import React, { useState } from "react";
import { setTitle } from "../../../helpers/MetaTag";
import ProfileStatistics from "../../../components/sections/front/User/ProfileStatistics";
import CurrentSubscription from "../../../components/sections/front/User/CurrentSubscription";
import CurrentAddress from "../../../components/sections/front/User/CurrentAddress";
import TransactionList from "../../../components/sections/front/User/TransactionList";
import useFetch from "../../../hooks/useFetch";
import { transactionListFront } from "../../../services/transactionService";
import dayjs from "dayjs";

const Transactions = () => {
  setTitle("Memory Doddle | Transactions");
  const [filters, setFilters] = useState({
    status: [],
    startDate: null,
    endDate: null,
  });
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("-createdAt"); // Default: newest first

  const {
    data: transactions = [],
    isLoading,
    refetch,
  } = useFetch({
    dependencies: ["transactions", filters, search, sort],
    fetchFunction: async () => {
      const query = {
        ...(search && { keyword: search }),
        ...Object.fromEntries(
          filters.status.map((val, i) => [`status[${i}]`, val])
        ),
        ...(filters.startDate && {
          startDate: dayjs(filters.startDate).format("YYYY-MM-DD"),
        }),
        ...(filters.endDate && {
          endDate: dayjs(filters.endDate).format("YYYY-MM-DD"),
        }),
        ...(sort && { sortQuery: sort }),
      };

      const res = await transactionListFront(query);
      return res?.docs?.data || [];
    },
  });

  // const transactiondata = [
  //   {
  //     _id: 1,
  //     status: "Success",
  //     date: "6 June, 2025",
  //     transactionId: "TXN0095862",
  //     amount: 19.99,
  //     description: "Transaction made against subscription."
  //   },
  //   {
  //     _id: 2,
  //     status: "Failed",
  //     date: "6 June, 2025",
  //     transactionId: "TXN0095862",
  //     amount: 29.99,
  //     description: "Transaction made against subscription."
  //   },
  //   {
  //     _id: 3,
  //     status: "Success",
  //     date: "6 June, 2025",
  //     transactionId: "TXN0095862",
  //     amount: 39.99,
  //     description: "Transaction made against order."
  //   },
  //   {
  //     _id: 4,
  //     status: "Failed",
  //     date: "6 June, 2025",
  //     transactionId: "TXN0095862",
  //     amount: 19.99,
  //     description: "Transaction made against order."
  //   },
  //   {
  //     _id: 5,
  //     status: "Success",
  //     date: "6 June, 2025",
  //     transactionId: "TXN0095862",
  //     amount: 29.99,
  //     description: "Transaction made against subscription."
  //   },
  //   {
  //     _id: 6,
  //     status: "Failed",
  //     date: "6 June, 2025",
  //     transactionId: "TXN0095862",
  //     amount: 39.99,
  //     description: "Transaction made against subscription."
  //   },
  //   {
  //     _id: 7,
  //     status: "Success",
  //     date: "6 June, 2025",
  //     transactionId: "TXN0095862",
  //     amount: 19.99,
  //     description: "Transaction made against order."
  //   },
  //   {
  //     _id: 8,
  //     status: "Failed",
  //     date: "6 June, 2025",
  //     transactionId: "TXN0095862",
  //     amount: 29.99,
  //     description: "Transaction made against order."
  //   },
  // ]

  return (
    <div className="relative space-y-5">
      <div className="grid grid-cols-3 gap-4 3xl:gap-6 items-start">
        <div className="relative col-span-2">
          {/* <TransactionList title={"Transactions"} data={transactiondata} isSort={true} isfilter={true} /> */}
          <TransactionList
            title="Transactions"
            data={transactions}
            isSort={true}
            isfilter={true}
            onSearch={setSearch}
            onSortChange={(val) => setSort(val)}
            onFilterChange={(newFilters) => setFilters(newFilters)}
          />
        </div>
        <div className="relative grid grid-cols-1 gap-4">
          <ProfileStatistics />
          <CurrentSubscription />
          <CurrentAddress />
        </div>
      </div>
    </div>
  );
};

export default Transactions;
